export const mapToArray = (enumObject) => {
  return Object.keys(enumObject).map(key => ({ ...enumObject[key] }))
}